import { Chip } from '@mui/material';
import { Confidence } from 'types/api/api-miners.types';

interface ConfidenceBadgeProps {
  confidence: Confidence | string;
  size?: 'small' | 'medium';
}

const LABELS: Record<string, string> = {
  measured: 'Metered',
  estimated: 'Estimated',
};

// Per-row confidence badge for device-level consumption rows (Plan 06 Task 4 — colo orgs only;
// keep v1 simple, no aggregate/summary badge). measured -> success, estimated -> default/warning.
export const ConfidenceBadge = ({ confidence, size = 'small' }: ConfidenceBadgeProps) => (
  <Chip
    label={LABELS[confidence] ?? confidence}
    color={confidence === 'measured' ? 'success' : 'default'}
    size={size}
    data-testid='confidence-badge'
  />
);
